import { render, staticRenderFns } from "./UploadFileModal.vue?vue&type=template&id=637e7f0c&scoped=true"
import script from "./UploadFileModal.vue?vue&type=script&lang=js"
export * from "./UploadFileModal.vue?vue&type=script&lang=js"
import style0 from "./UploadFileModal.vue?vue&type=style&index=0&id=637e7f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637e7f0c",
  null
  
)

export default component.exports